// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3922": "a498f753ff60","833": "95867d339c1f","8357": "dd422574e14d","8990": "7d69c8cdd354",}[chunkId] + ".css"
}